import { isFunction } from 'lodash'
// try catch 错误上传
export function captureException(error, cb) {
  // if (window.TruckSentry && isFunction(window.TruckSentry.captureException)) {
  //   window.TruckSentry.captureException(error, cb)
  // }
}

// 主动式上传各种错误
export function captureMessage(message, cb) {
  // if (window.TruckSentry && isFunction(window.TruckSentry.captureMessage)) {
  //   window.TruckSentry.captureMessage(message, cb)
  // }
}

/**
 * 标记用户信息全局设置,未来的异常事件自动携带用户信息
 * @param userInfo
 */
export function setUser(userInfo) {
  // if (window.TruckSentry && isFunction(window.TruckSentry.setUser)) {
  //   window.TruckSentry.setUser(userInfo || {})
  // }
}
